<form
  *ngIf="formInitialized"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="p-fluid">
  <p-tabMenu
    [model]="tabItems"
    [activeItem]="activeTabItem"
    (activeItemChange)="onTabChange($event)">
  </p-tabMenu>
  @if (selectedTab === 'general') {
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Name'"
        [name]="'title'"
        [colSize]="7"
        [formField]="form.get('title')">
        <input
          pInputText
          id="title"
          type="text"
          formControlName="title"
          class="p-input" />
      </app-form-field-wrapper>

      <app-icon-dropdown
        [formField]="form.get('icon')"
        [colSize]="2"
        [mode]="'fa'"
        formControlName="icon"
        label="Icon"
        name="icon"></app-icon-dropdown>
    </div>
    <div class="grid align-items-center mt-2">
      <app-form-field-wrapper
        [floatingLabel]="false"
        [label]="'Farbe'"
        [name]="'color'"
        [colSize]="9">
        <div
          class="color-swatch-panel flex flex-wrap gap-3 align-items-center surface-50 border-round-xl p-3">
          @for (token of colorTokens; track token) {
            <button
              type="button"
              pRipple
              class="color-swatch w-2rem h-2rem border-circle border-none cursor-pointer p-0 flex align-items-center justify-content-center shadow-1 transition-all transition-duration-150"
              [class]="'bg-' + token + '-500'"
              [class.color-swatch-active]="form.value.color === token"
              [pTooltip]="token"
              tooltipPosition="top"
              (click)="selectColor(token)">
              @if (form.value.color === token) {
                <i class="fas fa-check text-white text-xs"></i>
              }
            </button>
          }
          <button
            type="button"
            pRipple
            class="color-swatch w-2rem h-2rem border-circle border-1 surface-border surface-0 cursor-pointer flex align-items-center justify-content-center shadow-1 transition-all transition-duration-150"
            [class.color-swatch-active]="!form.value.color"
            pTooltip="keine Farbe"
            tooltipPosition="top"
            (click)="selectColor(null)">
            <i class="fas fa-xmark text-color-secondary text-xs"></i>
          </button>
        </div>
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [label]="'im Spotlight'"
        [name]="'spotlight'"
        [colSize]="2">
        <p-inputSwitch formControlName="spotlight"></p-inputSwitch>
      </app-form-field-wrapper>
    </div>
    <div class="grid">
      <app-form-field-wrapper
        [label]="'auf Startseite zeigen'"
        [name]="'showOnLandingPage'"
        [colSize]="4">
        <p-inputSwitch
          [ngModelOptions]="{ standalone: true }"
          [(ngModel)]="showOnLandingPage"
          (ngModelChange)="
            onLandingPageVisibilityChange($event)
          "></p-inputSwitch>
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [label]="'im öffentlichen Atlas sichtbar'"
        [name]="'visibleInPublicAtlas'"
        [colSize]="4">
        <p-inputSwitch formControlName="visibleInPublicAtlas"></p-inputSwitch>
      </app-form-field-wrapper>
      <app-form-field-wrapper
        [label]="'im internen Atlas sichtbar'"
        [name]="'visibleInInternalAtlas'"
        [colSize]="4">
        <p-inputSwitch formControlName="visibleInInternalAtlas"></p-inputSwitch>
      </app-form-field-wrapper>
    </div>
    <div class="grid mt-3">
      <app-form-field-wrapper
        [label]="'Beschreibung'"
        [floatingLabel]="false"
        [name]="'description'">
        <p-editor
          [modules]="{ nbspFix: true }"
          formControlName="description"
          [style]="{ height: '50px' }">
          <ng-template pTemplate="header">
            <span class="ql-formats">
              <button class="ql-bold"></button>
              <button class="ql-italic"></button>
              <button class="ql-underline"></button>
              <button type="button" class="ql-link" aria-label="Link"></button>
            </span>
          </ng-template>
        </p-editor>
      </app-form-field-wrapper>
    </div>
    <p-divider />
    <div class="grid">
      <app-workspace-dropdown
        name="workspaces"
        type="topic"
        formControlName="workspaces"></app-workspace-dropdown>
    </div>
  } @else if (selectedTab === 'lesezeichen') {
    <div class="grid">
      <app-bookmark-dropdown
        [selection]="form.value.defaultBookmark"
        label="Startansicht ist..."
        formControlName="defaultBookmark"></app-bookmark-dropdown>
    </div>

    <app-header
      text="Themenbereiche"
      icon="fas fa-layer-group"
      sub="Hier können Sie dem Thema Themenbereiche zuordnen, die als Navigation dienen sollen."></app-header>

    <p-pickList
      class="app-pick-list"
      [showSourceControls]="false"
      [dragdrop]="true"
      [filterBy]="bookmarkCategories.length > 10 ? 'title' : undefined"
      [sourceStyle]="{ height: '30rem' }"
      [targetStyle]="{ height: '30rem' }"
      (onMoveToSource)="updateFormValue()"
      (onMoveToTarget)="updateFormValue()"
      (onTargetReorder)="updateFormValue()"
      (onMoveAllToSource)="updateFormValue()"
      (onMoveAllToTarget)="updateFormValue()"
      [target]="selectedCategories"
      [source]="bookmarkCategories">
      <ng-template pTemplate="sourceHeader">
        <app-pick-list-header
          title="Themenbereiche"
          [count]="bookmarkCategories.length" />
      </ng-template>
      <ng-template pTemplate="targetHeader">
        <app-pick-list-header
          title="In diesem Thema"
          [count]="selectedCategories.length" />
      </ng-template>
      <ng-template let-category pTemplate="item">
        <div class="pl-row">
          <i class="fas fa-layer-group pl-icon"></i>
          <div class="pl-body">
            <span class="pl-name">{{ category.title }}</span>
            @if (categoryConflicts[category._id]; as conflictTitles) {
              <span class="pl-meta pl-warning">
                <i class="fas fa-triangle-exclamation mr-1"></i>
                bereits in „{{ conflictTitles }}“
              </span>
            }
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="emptymessagesource">
        <div class="pl-empty">Keine weiteren Einträge.</div>
      </ng-template>
      <ng-template pTemplate="emptyfiltermessagesource">
        <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
      </ng-template>
      <ng-template pTemplate="emptymessagetarget">
        <div class="pl-empty">
          Noch nichts ausgewählt – per Doppelklick, Pfeil oder Ziehen
          übernehmen.
        </div>
      </ng-template>
      <ng-template pTemplate="emptyfiltermessagetarget">
        <div class="pl-empty">Kein Eintrag passt zur Suche.</div>
      </ng-template>
    </p-pickList>
  }

  <p-divider></p-divider>
  <app-form-footer
    [cancelLevel]="1"
    [showRemoveButton]="
      !!(
        itemToEdit &&
        permissionService.checkThemeRights(itemToEdit._id, 'remove')
      )
    "
    [isEditMode]="!!itemToEdit"
    (removeClick)="
      itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.title) : undefined
    "></app-form-footer>
</form>
